<template>
    <div class="p-admin-conf-basic">
        <div class="card mb-3">
            <div class="card-header">キャンセルポリシーの設定</div>
            <div class="card-body" v-if="configurations">
                <div v-for="(conf, index) in configurations">
                    <div v-if="conf.value_type === confValue.text" class="m-1">
                        <div class="form-group m-form__group">
                            <quill-editor
                                ref="quillEditorCancelPolicy"
                                v-model="configurations[index].value"
                                :id="`key-${conf.key}`"
                                :options="editorOption">
                            </quill-editor>
                            <div
                                v-if="errors[ `${index}.${helper.valueField(conf)}` ]"
                                class="invalid-feedback d-block mt-1">
                                {{ errors[ `${index}.${helper.valueField(conf)}` ][0]}}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="d-flex justify-content-end">
                    <button
                        @click="updateConfigurations"
                        :disabled="inProgress"
                        class="btn btn-yokumiru-orange btn-settings mt-3">
                        保存
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import constants from '../../../constants'
import YokumiruHelper from '../../../YokumiruHelper'

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import { quillEditor } from 'vue-quill-editor'

export default {
    components: {
        quillEditor,
    },

    props: {
        conf: {
            type: Array,
            required: true,
        },
    },

    data: function () {
        return {
            helper: YokumiruHelper,
            configurations: [],
            errors: {},
            inProgress: false,
            confCategory: constants.confCategory,
            confValue: constants.confValue,
            editorOption: {
                modules: {
                    toolbar: {
                        container: [
                            ['bold', 'italic', 'underline'],
                            [{ 'header': [1, 2, 3, 4, false] }],
                            [{ 'color': [] }, { 'background': [] }],
                            [{ 'list': 'ordered'}, { 'list': 'bullet' }],
                            ['link', 'divider'],
                        ],
                        // @see https://quilljs.com/docs/modules/toolbar/#handlers
                        handlers: {
                            divider: function() {
                                this.quill.format('divider', '-')
                            },
                        },
                    },
                },
                placeholder: 'ここに内容を入力してください',
            },
        }
    },

    computed: {
        /**
         * 更新データ準備
         *
         * @return {object}
         */
        preparedConfigurations: function () {
            return this.helper.bindConfigurationsValue(this.configurations)
        },
    },

    methods: {
        /**
         * 設定更新
         */
        updateConfigurations: async function () {
            if (this.inProgress) return
            this.inProgress = true

            const endpoint = constants.admin.configurations.endpoint.base

            await axios.post(endpoint, this.preparedConfigurations)
                .then(() => {
                    this.errors = {}
                    bus.$emit('alert-success', '設定を更新しました。')
                })
                .catch(({response}) => {
                    this.errors = response.data.errors
                    bus.$emit('alert-danger')
                })

            this.inProgress = false
        },
    },

    watch: {
        conf: function (conf) {
            this.configurations = conf
        },
    }
}
</script>
